import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { Workspace } from '@core/models'
import { NgTemplateOutlet } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'

@Component({
    selector: 'app-workspace',
    templateUrl: './workspace.component.html',
    styleUrls: ['./workspace.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, NgTemplateOutlet, TbIconComponent],
})
export class WorkspaceComponent {
    @Input() workspace!: Workspace
    @Input() selectedWorkspaceGuid!: string
    @Input() canEdit: boolean = true
    @Input() canDelete: boolean = true
    @Input() showSelectedIcon = false

    @Output() edit = new EventEmitter<void>()
    //TODO: delete EE
    @Output() delete = new EventEmitter<void>()
    @Output() selectWorkspace: EventEmitter<Workspace> = new EventEmitter<Workspace>()

    hovered = false

    @HostListener('mouseover', ['$event'])
    mouseOver() {
        this.hovered = true
    }

    @HostListener('mouseleave', ['$event'])
    mouseLeave() {
        this.hovered = false
    }

    get showSettings() {
        return this.hovered
    }

    get workspaceColor(): string | null {
        return this.workspace.color?.value || null
    }

    get workspaceIcon(): string {
        return this.workspace.icon?.value || ''
    }

    get workspaceName(): string {
        return this.workspace.name?.value || ''
    }

    get isSelected() {
        return this.workspace.guid === this.selectedWorkspaceGuid
    }
}
